import ProductCategories from './ProductCategories';

export default ProductCategories;
